import { Controller } from "react-hook-form";
import Select from "react-select";
import { REQ_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
interface IFADProps {
  type: string;
  register: any;
  errors?: any;
  inputName: string;
  className?: string;
  placeholder?: string;
  required?: boolean;
  pattern?: {
    type: any;
    message: string;
  };
  inputDivClassName?: string;
  inputTabIndex?: number;
  control: any;
  dropdownName: string;
  dropdownClassName?: string;
  optionList: any[];
  dropPlaceholder?: string;
  dropdownRequired?: boolean;
  dropdownErrors?: any;
  dropdownDivClassName?: string;
  dropdownTabIndex?: number;
  dorpdownOnChange?: (data: string) => void;
}
export default function InputFieldAndDropdown(props: IFADProps) {
  const {
    type,
    register,
    errors,
    inputName,
    className,
    placeholder,
    required = false,
    pattern,
    inputDivClassName,
    inputTabIndex,
    control,
    dropdownName,
    dropdownClassName,
    optionList,
    dropPlaceholder,
    dropdownRequired,
    dropdownErrors,
    dropdownDivClassName,
    dropdownTabIndex,
    dorpdownOnChange,
  } = props;
  let inputClassName = className || "";
  if (errors) {
    inputClassName += " border-danger";
  }
  let inputDropClassName = dropdownClassName || "";
  if (errors) {
    inputDropClassName += " border-danger";
  }
  return (
    <>
      <div className={inputDivClassName}>
        <input
          tabIndex={inputTabIndex}
          type={type}
          name={inputName}
          className={inputClassName}
          {...register(inputName, {
            ...(required && {
              required: {
                value: true,
                message: REQ_ERR_MSG,
              },
            }),
            ...(pattern && {
              pattern: {
                value: pattern.type,
                message: pattern.message,
              },
            }),
          })}
          placeholder={placeholder}
        />
        {errors && (
          <div>
            <span className="text-danger">{errors.message}</span>
          </div>
        )}
      </div>
      <div className={dropdownDivClassName}>
        <Controller
          name={dropdownName}
          control={control}
          rules={{
            ...(dropdownRequired && {
              required: { value: true, message: REQ_ERR_MSG },
            }),
          }}
          render={({ field: { onChange, value } }) => (
            <Select
              tabIndex={dropdownTabIndex}
              options={optionList}
              placeholder={dropPlaceholder}
              value={
                value ? optionList.find((opt) => opt.value === value) : value
              }
              onChange={(d) => {
                const selectedValue = d ? d.value : "";
                onChange(selectedValue);
                if (dorpdownOnChange) {
                  dorpdownOnChange(selectedValue);
                }
              }}
              className={inputDropClassName}
              classNamePrefix="pt"
              //menuIsOpen={true}
            />
          )}
        />
        {dropdownErrors && (
          <div>
            <span className="text-danger">{dropdownErrors.message}</span>
          </div>
        )}
      </div>
    </>
  );
}
